import { useNavigate } from 'react-router-dom';
import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

import logo from '../moodmealslogo.png';
// import Modal from './ErrorModal';
import '../styles/AdminPage.css';

const AdminPage=({onLogout,logoutSuccess,setLogoutSuccess})=>{

    const [items,setItems]=useState([]);
    const [itemType,setItemType]=useState('users');
    const [isProdEditing,setIsProdEditing]=useState(false);
    const [isUserEditing,setIsUserEditing]=useState(false);
    const [isLoading,setIsLoading]=useState(true);
    // const [message,setMessage]=useState('');
    // const [showModal,setShowModal]=useState(false);

    const [editUserValues,setEditUserValues]=useState({
        _id: '',
        role: '',
        avatar: '',
        firstname: '',
        lastname: '',
        gender: '',
        email: '',
        contact_num: '',
        password: ''
    });
    const [editProdValues,setEditProdValues]=useState({
        _id: '',
        prod_img: '',
        prod_name: '',
        prod_price: '',
        prod_qty: ''
    });

    const navigate=useNavigate();

    useEffect(()=>{
        setTimeout(()=>{
          setIsLoading(false);
        },2000);
    },[]);

    const onHome=()=>{
        navigate('/');
    }

    useEffect(()=>{
        if(logoutSuccess){
            setIsLoading(true);
            setTimeout(() => {
                setIsLoading(false);
                setLogoutSuccess(false);
                navigate('/');
            }, 2000);
        }
    },[logoutSuccess,navigate,setLogoutSuccess]);

    useEffect(()=>{
        setIsLoading(true);
        axios.get('/api/getUsers')
        .then(res=>{
            setItems(res.data.users);
            setIsLoading(false);
        })
        .catch(err=>{
            console.error('Something went wrong', err);
            setIsLoading(false);
        })
        .finally(()=>{
            setIsLoading(false);
        });
    },[]);
    
    const handleItems=useCallback((type)=>{
        let url=``;
        if(type===`users`){
            url=`/api/getUsers`;
            setItemType('users');
        }else if(type===`products`){
            url=`/api/getProducts`;
            setItemType('products');
        }
        axios.get(url)
        .then(res=>{
            setItems(res.data[type]);
        })
        .catch(err=>{
            console.error('Something went wrong', err);
        });
    }, []);

    const editUserItem=(id,ro,av,fname,lname,gen,em,pn,pw)=>{
        setIsUserEditing(true);
        setEditUserValues({
            _id: id,
            role: ro,
            avatar: av,
            firstname: fname,
            lastname: lname,
            gender: gen,
            email: em,
            contact_num: pn,
            password: pw
        });
    };

    const editProdItem=(id,img,name,price,qty)=>{
        setIsProdEditing(true);
        setEditProdValues({
            _id: id,
            prod_img: img,
            prod_name: name,
            prod_price: price,
            prod_qty: qty
        });
    };

    const updateItem=(e)=>{
        e.preventDefault();
        if(itemType==='users'){
            // if(items.find(user=>user._id!==editUserValues._id)&&items.find(user=>user.email===editUserValues.email)){
            //     setMessage("Email already exists. Please try again.");
            //     setShowModal(true);
            //     return;
            // }else if(items.find(user=>user._id!==editUserValues._id)&&items.find(user=>user.contact_num===editUserValues.contact_num)){
            //     setMessage("Phone number already exists. Please try again.");
            //     setShowModal(true);
            //     return;
            // }
            axios.put(`/api/users/update/${editUserValues._id}`,{
                role:editUserValues.role,
                firstname:editUserValues.firstname,
                lastname:editUserValues.lastname,
                gender:editUserValues.gender,
                email:editUserValues.email,
                contact_num:editUserValues.contact_num,
                password:editUserValues.password
            },{withCredentials:true})
            .then(res=>{
                handleItems('users');
                setIsUserEditing(false);
            })
            .catch(err=>{
                console.error('Error updating this item:', err);
            });
        }else if(itemType==='products'){
            // if(items.find(product=>product._id!==editProdValues._id)&&items.find(product=>product.prod_name===editProdValues.prod_name)){
            //     setMessage("Product name already exists. Please try again.");
            //     setShowModal(true);
            //     return;
            // }
            axios.put(`/api/product/update/${editProdValues._id}`,{
                prod_name:editProdValues.prod_name,
                prod_price:editProdValues.prod_price,
                prod_qty:editProdValues.prod_qty
            },{withCredentials:true})
            .then(res=>{
                handleItems('products');
                setIsProdEditing(false);
            })
            .catch(err => {
                console.error('Error updating this item:', err);
            });
        }
    };

    const removeItem=(e,id)=>{
        e.preventDefault();
        if(itemType==='users'){
            axios.delete(`/api/users/delete/${id}`,{withCredentials:true})
            .then(res=>{
                setItems(items.filter(item=>item._id!==id));
            })
            .catch(err=>{
                console.error('Error deleting this item:', err);
            });
        }else if(itemType==='products'){
            axios.delete(`/api/product/delete/${id}`,{withCredentials:true})
            .then(res=>{
                setItems(items.filter(element=>element._id!==id));
            })
            .catch(err => {
                console.error('Error removing cart item:', err);
            });
        }
    };

    useEffect(()=>{
        handleItems(itemType);
    },[handleItems,itemType]);

    // const closeModal=()=>{
    //     setShowModal(false);
    // };

    return(
        <>
            {isLoading?(
                <div className="loadingContainer">
                    <img src={logo} alt="Loading..." className="moodmeals-loading-logo"/>
                </div>
            ):(
            <>
                <div className='wrapper'>
                    <header className='header'>
                        <div className='header-items'>
                            <div className='logo-name'>
                                <img src={logo} alt="MoodMeals Logo" loading="lazy"/>
                                <h1>Admin</h1>
                            </div>
                            <div className='sidebar'>
                                <nav>
                                    <ul>
                                        <li className='sidebar-list' onClick={()=>handleItems('users')}>Users</li>
                                        <li className='sidebar-list' onClick={()=>handleItems('products')}>Products</li>
                                        <li className='sidebar-list' onClick={handleItems}>Orders</li>
                                    </ul>
                                </nav>
                                <div className='sidebar-btn'>
                                    <button onClick={onHome}>Home</button>
                                    <button onClick={onLogout}>Logout</button>
                                </div>
                            </div>
                        </div>
                    </header>
                    <main className='main'>
                        {itemType==='users'&&(
                            <div className='items'>
                                {isLoading ? (
                                    <div className='flex-1 items-center justify-center'>
                                        <h2 className='text-2xl font-bold'>Loading users...</h2>
                                    </div>
                                ) : isUserEditing?(
                                    <>
                                        <div className='edit-prod'>
                                            <h2>Edit User</h2>
                                        </div>
                                        <div className='edit-info'>
                                            <img src={editUserValues.avatar} alt={`User ${editUserValues._id}`}/> 
                                            <div className='edit-input'>
                                                <p><b>Role: </b>
                                                    <select className='edit-glass-select' value={editUserValues.role} onChange={(e)=>setEditUserValues({...editUserValues, role: e.target.value})}>
                                                        <option value="" selected></option>
                                                        <option>User</option>
                                                        <option>Admin</option>
                                                    </select>                                                
                                                </p>
                                                <p><b>First Name: </b><input type='text' value={editUserValues.firstname} onChange={(e)=>setEditUserValues({...editUserValues, firstname: e.target.value})}/></p>
                                                <p><b>Last Name: </b><input type='text' value={editUserValues.lastname} onChange={(e)=>setEditUserValues({...editUserValues, lastname: e.target.value})}/></p>
                                                <p><b>Gender: </b>
                                                    <select className='edit-glass-select' value={editUserValues.gender} onChange={(e)=>setEditUserValues({...editUserValues, gender: e.target.value})}>
                                                        <option value="" selected></option>
                                                        <option>Male</option>
                                                        <option>Female</option>
                                                    </select>                                                
                                                </p>
                                                <p><b>Email: </b><input type='email' value={editUserValues.email} onChange={(e)=>setEditUserValues({...editUserValues, email: e.target.value})}/></p>
                                                <p><b>Contact No: </b><input type='text' minLength={11} maxLength={12} value={editUserValues.contact_num} onChange={(e)=>setEditUserValues({...editUserValues, contact_num: e.target.value})}/></p>
                                                <p><b>Password: </b><input type='password' value={editUserValues.password} onChange={(e)=>setEditUserValues({...editUserValues, password: e.target.value})} placeholder='Type your new password here!'/></p>
                                            </div>
                                            <div className='edit-btn'>
                                                <button className='update' onClick={(e)=>updateItem(e)}></button>
                                                <button className='cancel' onClick={()=>setIsUserEditing(false)}></button>
                                            </div>
                                        </div>
                                    </>
                                ) : items?.length > 0 ? (
                                    <>
                                        <div className='add-prod'>
                                            <h2>List of Users</h2>
                                            <button>Compose</button>
                                        </div>
                                        <ul>
                                            {items.map((element,index)=>(
                                                <li key={index}>
                                                    <div className='items-info'>
                                                        <img src={element.avatar} alt={`User ${index}`}/> 
                                                        <div className='items-details'>
                                                            <p><b>Role: </b>{element.role}</p>
                                                            <p><b>Name: </b>{element.firstname} {element.lastname}</p>
                                                            <p><b>Gender: </b>{element.gender}</p>
                                                            <p><b>Email: </b>{element.email}</p>
                                                            <p><b>Contact No: </b>{element.contact_num}</p>
                                                            <p><b>Password: </b><em>edit to show...</em></p>
                                                        </div>
                                                    </div>
                                                    <div className='items-btn'>
                                                        <button className='edit' onClick={()=>editUserItem(
                                                            element._id,
                                                            element.role,
                                                            element.avatar,
                                                            element.firstname,
                                                            element.lastname,
                                                            element.gender,
                                                            element.email,
                                                            element.contact_num,
                                                            element.password
                                                        )}></button>
                                                        <button className='delete' onClick={(e)=>removeItem(e,element._id)}></button>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                ) : (
                                    <div className='flex-1 items-center justify-center'>
                                        <h2 className='text-2xl font-bold'>No users available.</h2>
                                    </div>
                                )}
                            </div>
                        )}
                        {itemType==='products'&&(
                            <div className='items'>
                                {isLoading ? (
                                    <div className='flex-1 items-center justify-center'>
                                        <h2 className='text-2xl font-bold'>Loading products...</h2>
                                    </div>
                                ) : isProdEditing ? (
                                    <>
                                        <div className='edit-prod'>
                                            <h2>Edit Product</h2>
                                        </div>
                                        <div className='edit-info'>
                                            <img src={editProdValues.prod_img} alt={`Product ${editProdValues._id}`}/> 
                                            <div className='edit-input'>
                                                <p><b>Name: </b><input value={editProdValues.prod_name} onChange={(e)=>setEditProdValues({...editProdValues, prod_name: e.target.value})}/></p>
                                                <p><b>Price: ₱</b><input value={editProdValues.prod_price} onChange={(e)=>setEditProdValues({...editProdValues, prod_price: e.target.value})}/></p>
                                                <p><b>Quantity: </b><input value={editProdValues.prod_qty} onChange={(e)=>setEditProdValues({...editProdValues, prod_qty: e.target.value})}/></p>
                                            </div>
                                            <div className='edit-btn'>
                                                <button className='update' onClick={(e)=>updateItem(e)}></button>
                                                <button className='cancel' onClick={()=>setIsProdEditing(false)}></button>
                                            </div>
                                        </div>
                                    </>
                                ) : items?.length > 0 ?(
                                    <>
                                        <div className='add-prod'>
                                            <h2>List of Products</h2>
                                            <button>Compose</button>
                                        </div>
                                        <ul>
                                            {items.map((element,index)=>(
                                                <li key={index}>
                                                    <div className='items-info'>
                                                        <img src={element.prod_img} alt={`Product ${index}`}/> 
                                                        <div className='items-details'>
                                                            <p><b>Name: </b>{element.prod_name}</p>
                                                            <p><b>Price: ₱ </b>{element.prod_price}</p>
                                                            <p><b>Quantity: </b>{element.prod_qty}</p>
                                                        </div>
                                                    </div>
                                                    <div className='items-btn'>
                                                        <button className='edit' onClick={()=>editProdItem(
                                                            element._id,
                                                            element.prod_img,
                                                            element.prod_name,
                                                            element.prod_price,
                                                            element.prod_qty
                                                        )}></button>
                                                        <button className='delete' onClick={(e)=>removeItem(e,element._id)}></button>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </>
                                ) : (
                                    <div className='flex-1 items-center justify-center'>
                                        <h2 className='text-2xl font-bold'>No products available.</h2>
                                    </div>
                                )}
                            </div>
                        )}
                    </main>
                </div>
                {/* {showModal&&<Modal message={message} onClose={closeModal}/>} */}
            </>
            )}
        </>
        )
    }

export default AdminPage;